const CELL_W = 300;
const CELL_H = 190;
const CLUSTER_GAP = 160;
const MAX_ROW_W = 2600;

function keywordClusters(citations) {
  const parent = citations.map((_, i) => i);
  const find = (i) => (parent[i] === i ? i : (parent[i] = find(parent[i])));
  const byKeyword = {};
  citations.forEach((c, i) =>
    (c.keywords || []).forEach((k) => {
      const key = k.trim().toLowerCase();
      if (!key) return;
      if (byKeyword[key] === undefined) byKeyword[key] = i;
      else parent[find(i)] = find(byKeyword[key]);
    })
  );
  const groups = {};
  const loose = [];
  citations.forEach((c, i) => {
    if (!(c.keywords || []).some((k) => k.trim())) return loose.push(c);
    (groups[find(i)] = groups[find(i)] || []).push(c);
  });
  const clusters = Object.values(groups).sort((a, b) => b.length - a.length);
  if (loose.length) clusters.push(loose);
  return clusters;
}

// Returns { [citationId]: {x, y} } packing each keyword cluster as a tidy grid.
export function clusterPositions(citations) {
  const out = {};
  let x = 0;
  let y = 0;
  let rowH = 0;
  keywordClusters(citations).forEach((group) => {
    const cols = Math.ceil(Math.sqrt(group.length));
    const w = cols * CELL_W;
    const h = Math.ceil(group.length / cols) * CELL_H;
    if (x > 0 && x + w > MAX_ROW_W) {
      x = 0;
      y += rowH + CLUSTER_GAP;
      rowH = 0;
    }
    group.forEach((c, i) => {
      out[c.id] = { x: x + (i % cols) * CELL_W, y: y + Math.floor(i / cols) * CELL_H };
    });
    x += w + CLUSTER_GAP;
    rowH = Math.max(rowH, h);
  });
  return out;
}
